
import React from "react";
import TiptapEditor from "../../../ui/TiptapEditor";


function CancellationPolicy({ value, setValue }) {
    return (
        <section className="mt-6">
            <h3 className="text-lg font-semibold mb-2">
               Cancellation Policy
            </h3>
            <TiptapEditor
                content={value}
                onChange={setValue}
                placeholder="Start writing your template..."
            />

        </section>
    )
}

export default CancellationPolicy